import { createContext, useContext } from 'react';
import { FileLabelResponseDto } from '@/shared/api';

interface KnowledgeBaseFileExplorerContextProps {
  isPolling?: boolean;
  labels?: Array<FileLabelResponseDto>;
  onLabelSelect?: (fileId: string, labelId: string) => Promise<void>;
  onLabelDeselect?: (fileId: string, labelId: string) => Promise<void>;
  onLabelCreate?: (name: string) => Promise<FileLabelResponseDto>;
}

export const KnowledgeBaseFileExplorerContext =
  createContext<KnowledgeBaseFileExplorerContextProps>({});

export const useKnowledgeBaseFileExplorerContext = () =>
  useContext(KnowledgeBaseFileExplorerContext);
